import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import FormLabel from "@material-ui/core/FormLabel";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Chip from "@material-ui/core/Chip";
import WarningTwoToneIcon from "@material-ui/icons/WarningTwoTone";
import { yellow, blue } from "@material-ui/core/colors";
import NavDrawer from "./NavDrawer";
import { connect } from "react-redux";
import { updateNavTitle, fetchAllSupplierImages } from "../actions";
import "./App.css";
import _ from "lodash";

class Home extends React.Component {
  getImagesData() {
    if (!_.isEmpty(this.props.user)) {
      //check if image data already exists in memory
      const isDataCached = this.props.images.isCached;

      //if it hasn't retrieved data yet then do so from firestore
      if (!isDataCached) {
        console.log("[HOME] >>> Getting ALL images from firestore!!!");
        this.props.user.supplierList.map(s => {
          const supplierId = s.split("_")[0];
          this.props.fetchAllSupplierImages(supplierId);
        });
      }
    }
  }

  getSupplierList() {
    let supplierList = [];
    if (!_.isEmpty(this.props.user)) {
      this.props.user.supplierList.map(s => {
        supplierList.push(s);
      });
    }
    return supplierList;
  }

  componentDidMount() {
    console.log(
      "[HOME] COMPONENTDIDMOUNT:",
      this.props.auth.uid,
      this.props.user.uid
    );

    //set the title
    this.props.updateNavTitle("Dashboard", false);

    if (this.props.auth.uid === this.props.user.uid) {
      //get images data
      this.getImagesData();
    }
  }

  componentDidUpdate(prevProps) {
    console.log(
      "[HOME] COMPONENTDIDUPDATE:",
      prevProps.user.uid,
      this.props.user.uid
    );
    if (prevProps.user.uid !== this.props.user.uid) {
      //get images data
      this.getImagesData();
    }
  }

  render() {
    console.log("[HOME] RENDER");
    const navDrawer = bool => {
      if (bool) {
        return <NavDrawer />;
      }
    };

    const supplierList = this.getSupplierList();

    const { images } = this.props;
    const totalDefectiveItemCount = images.masterItemList.length;
    const totalDefectiveImageCount = _.values(images).length - 3;

    return (
      <div>
        <Container
          maxWidth={false}
          style={{
            background: "#F0f0f0",
            padding: "0 0px",
            overflow: "hidden"
          }}
        >
          {navDrawer(this.props.auth)}
          <div
            style={{
              background: "#789ba3",
              color: "#fff",
              padding: "30px 50px 30px",
              overflow: "hidden"
            }}
          >
            <Typography
              variant="h6"
              component="h6"
              style={{ fontFamily: '"Google Sans", sans-serif' }}
            >
              {supplierList.map((supplier, index) => (
                <div key={index}>
                  {supplier.split("_")[1]}{" "}
                  <Chip
                    size="small"
                    label={supplier.split("_")[0]}
                    variant="outlined"
                    style={{
                      color: "#fff",
                      marginTop: "-2px",
                      height: "15px",
                      fontSize: "0.6rem"
                    }}
                  />
                </div>
              ))}
            </Typography>
          </div>
          <div
            style={{
              height: "80vh",
              marginLeft: "50px"
            }}
          >
            <div style={{ padding: "30px 0 0" }}>
              <Paper elevation={3} style={{ width: "350px", padding: "15px" }}>
                <Grid container>
                  <Grid item>
                    <FormLabel>Defective Items</FormLabel>
                    <Grid
                      container
                      wrap="nowrap"
                      spacing={2}
                      style={{ marginTop: "5px" }}
                    >
                      <Grid item>
                        <WarningTwoToneIcon style={{ color: yellow[900] }} />
                      </Grid>
                      <Grid item xs>
                        <Typography
                          style={{ fontSize: "0.9rem", marginTop: "1px" }}
                        >
                          <span
                            style={{ fontSize: "1rem", fontWeight: "bold" }}
                          >
                            {totalDefectiveItemCount}
                          </span>{" "}
                          total items that require your attention
                        </Typography>
                        <Typography
                          style={{ fontSize: "0.9rem", marginBottom: "10px" }}
                        >
                          <span
                            style={{ fontSize: "1rem", fontWeight: "bold" }}
                          >
                            {totalDefectiveImageCount}
                          </span>{" "}
                          total images
                          <Link
                            to={{ pathname: "/image-portal" }}
                            style={{
                              color: blue["A700"],
                              textDecoration: "none",
                              fontWeight: "bold",
                              fontSize: "0.8rem",
                              marginLeft: "8px"
                            }}
                          >
                            (view all)
                          </Link>
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </div>
          </div>
        </Container>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    images: state.imageList,
    auth: state.auth,
    user: state.user
  };
}

Home.propTypes = {
  images: PropTypes.object,
  auth: PropTypes.object,
  user: PropTypes.object,
  updateNavTitle: PropTypes.func,
  fetchAllSupplierImages: PropTypes.func
};

export default connect(mapStateToProps, {
  updateNavTitle,
  fetchAllSupplierImages
})(Home);
